import styled, {keyframes} from 'styled-components';
import {Column, Row} from '../../common/Layouts/Layouts';
import Image from '../../common/Image/Image';
import SignUpLockIcon from '../../../../Icons/SignUpLockIcon';

export const OuterWrapperDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
  cursor: pointer;
`;

export const OfferOuterWrapperDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-image: linear-gradient(86deg, #cdf6e8, #c7efe5 41%, #bfe4e0);
  border-radius: 10px;
  border: solid 1px #a2dad4;
  position: relative;
  top: -1.5rem;
`;

export const ImageGalleryWrapperDiv = styled.div(
  props => `
    width: 24rem;
    display: flex;
    margin: 1rem 2.9rem 1rem 1rem;
    position: relative;
`,
);

/** This wrapper class is for meta landing */

export const WrapperSectionMetaDiv = styled.div`
  width: 100%;
  border-radius: 1rem;
  box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
  border: ${props => props.isSoldout ? 'solid 0.7px #eb2026' : 'solid 0.7px #bababa'};
  background-color: ${props => props.isSoldout ? '#fff6f6' : '#ffffff'};
  display: flex;
  height: 26rem;
  ${ props => props.isSoldout 
    ? '' : `&:hover {
      background-color: #f4faff;
      border: 0.7px solid #008cff;
    }`
  }
`;

// export const WrapperSection = styled.div(
//   props => `
//   margin: ${props.theme.spacing.large} 0 0;
//   background-color: ${props.theme.colors.white.base};
//   flex-direction: row;
//   flex-wrap: wrap;
//   display: flex;
//   width: 100%;
//   height: 28rem;
//   position: relative;
//   border-radius: ${props.theme.misc.borderRadius.large};
// `,
// );

export const MetaLandingWrapper = styled.div(
  props => `

  display:flex;
  justify-content: space-between;
  width: ${props.width};
  border-radius:${props.theme.misc.borderRadius.xxxlarge};
  border-bottom-right-radius: ${props.theme.misc.borderRadius.custom(0)};
  border-bottom-left-radius: ${props.theme.misc.borderRadius.custom(0)};
  background-color: ${props.theme.colors.goBrand.orange};
  padding:${props.theme.spacing.base};
  position:relative;
  top:${props.theme.spacing.large.l15};
  left:${props.theme.spacing.large.l15};

`,
);

export const MetaLandingText = styled.p(
  props => `
  font-size:${props.theme.font.large.font14};
  font-weight:bold;
  color: ${props.theme.colors.white.base};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`,
);

export const MetaWrappedImg = styled(Image)(
  props => `
  // width: 3rem;
  // height: 2rem;
  display: flex;
  position: relative;
  border-radius: ${props.theme.misc.borderRadius.xxlarge};
  object-fit: cover;
    `,
);

export const HotelCardInfoWrapperDiv = styled.div`
  width: 64rem;
  display: flex;
  flex-direction: row;
`;

// ==================================== HOTEL INFO STYLES START HERE ====================================

export const HotelInfoWrapperDiv = styled.div(
  props => `
  display: flex;
  width:47rem;
  padding:1rem 1.5rem 1rem 0;
  flex-direction: column;
  justify-content: space-between;
`,
);

export const PersuasionWrapperDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-end;
`;

export const HeadingInfoWrapperDiv = styled(Column)`
  width: 100%;
`;

export const HeadingDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.5rem;
`;

export const HeadingWrapperDiv = styled.div(
  props => `
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-right: ${props.theme.spacing.small.s5};
  `,
);

export const StarRatingWrapperSpan = styled.span(
  props => `
  display: inline-flex;
`,
);

export const HotelTypeTagWrap = styled.div`
  width: 100%;
  display: flex;
`;

export const HotelTypeTag = styled.span(
  props => `
    border-radius: 4px;
    border: solid 1px #5aa0d5;
    background-color: #ffffff;
    padding: 0.5rem 0.9rem;
    display: flex;
`,
);

export const HotelTypeText = styled.p`
  font-size: 1.1rem;
  color: #0061aa;
  font-weight: bold;
  text-transform: uppercase;
`;

export const HotelNameWrapperDiv = styled.div(
  props => `
    width:100%;
    display: flex;
    padding-bottom: 1.2rem;
`,
);

export const HotelNameAddressWrap = styled.div`
  width: 85%;
  display: flex;
  flex-direction: column;
`;

export const HotelNameWrap = styled.div`
  width: 100%;
  display: flex;
  padding-bottom: 2px;
  align-items: center;
  padding-right: 1.5rem;
`;

export const HotelNameTextSpan = styled.p(
  props => `
  font-size:2.2rem;
  color: #000000;
  font-weight: ${props.theme.font.fontWeight.black};
  letter-spacing: -0.49px;
  line-height: 1.3;
  
  span{
    padding-right:1rem;
  }
`,
);

export const HotelAddresWrap = styled.div`
  width: 100%;
  display: flex;
`;

export const AddresText = styled.p`
  font-size: 1.2rem;
  letter-spacing: -0.27px;
  color: #4a4a4a;
`;

export const HotelRatingWrap = styled.div`
  width: 15%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const RoomTypeWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding: 0.6rem 0 0.6rem 0;
  align-items: center;
`,
);

export const RoomTypeWrapperDivNew = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding: 0.6rem 0 0.6rem 0;
  align-items: center;
`,
);

export const PersuationOuterBlock = styled.div`
  width: 100%;
  display: flex;
  padding: 0 0 1.5rem;
  flex-direction: column;
`;

export const PersuationTagBlock = styled.div`
  width: 100%;
  display: flex;
`;

export const PersuationTagNew = styled.p`
  display: flex;
  padding: 0.4rem 0.8rem;
  border: 1px solid #e7e7e7;
  background-color: #f1f1f1;
  border-radius: 4px;
  font-size: 1.1rem;
  color: #4a4a4a;
  margin-right: 1rem;
`;
export const AmenitiesWrapper = styled.div`
  width: 100%;
  display: flex;
  padding-top: 1rem;
  align-items: center;
`;

export const RoomTypeTextWrapper = styled.span(
  props => `
  color: ${props.theme.colors.grey.grey75};
  line-height: 1.3;
  max-width: ${props.maxWidth || '30rem'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`,
);

export const RoomTypeIconWrapperSpan = styled.span`
  margin-right: 0.8rem;
`;

export const PersausionWrapperDiv = styled(Row)`
  margin-top: 0.2rem;
  margin-right: 0.5rem;
`;

export const LocationInfoWrapperDiv = styled(Row)`
  align-self: flex-start;
`;

export const HotelAddress = styled.p`
  font-size: 1.2rem;
  color: #4a4a4a;
  letter-spacing: -0.27px;
`;

export const LocationInfo = styled.p`
  font-size: 1.2rem;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  margin-left: 0.5rem;
`;

export const LocDivider = styled.p`
  color: #9b9b9b;
  padding-right: 0.3rem;
`;

export const LocDisatnce = styled.p`
  color: #249995;
  padding-right: 0.3rem;
`;
export const LocNameInfo = styled.p`
  color: #4a4a4a;
`;

export const BlueText = styled.span(
  props => `
    color: ${props.theme.colors.goBrand.blue};
`,
);

// =========================== HOTEL INFO STYLES END HERE ===========================

// =========================== HOTEL PRICING STYLES START HERE ===========================

export const HotelPricingInfoWrapperDiv = styled.div(
  props => `
    width:16.9rem;
    display: flex;
    border-left: 0.7px solid #e6e6e6;
    background-color: #f7f5f5;
    border-radius: 0 1rem 1rem 0;
    flex-direction: column;
    justify-content: space-between;

    ${WrapperSectionMetaDiv}: hover & {
        background-color: #def0ff;
        border-left: 0.7px solid #b0cde3;
    }
`,
);

export const PriceInnerWrapper = styled.div(
  props => `
      width:100%;
      display: flex;
      padding: ${props.spelSprice ? '1rem 1rem 0 1rem' : '1rem'} ;
      height: ${props.spelSprice ? '18rem' : '100%'};
      flex-direction: column;
      justify-content: space-between;
  `,
);

export const ContentWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
  padding: 2rem;
`,
);

export const PricingContentWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
  justify-content: flex-end;

`,
);

export const PaxSplitWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: ${props.theme.spacing.small.s5} 0 ${props.theme.spacing.small.s5} 0;
  border-radius: ${props.theme.misc.borderRadius.small};
`,
);

export const PaxSplitTextWrapper = styled.span`
  /* color: white; */
  color: #4a4a4a;
  font-size: 1.2rem;
  font-weight: bold;
`;

// ! ERROR: must move gradient styles also into theme object, here, this cannot support different gradient
// for different level(s)
export const TierLevelWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding: ${props.theme.spacing.small.s2} ${props.theme.spacing.small.s5} ${props.theme.spacing.small.s2}
    ${props.theme.spacing.base};
  background-image: radial-gradient(circle at 2% 16%, #d2bd60, #aa9a55);
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom: ${props.theme.spacing.small.s5};
`,
);

export const TierLevelTextWrapper = styled.span(
  props => `
  color: ${props.theme.colors.white.base};
  font-weight: bold;
  text-transform: uppercase;
  display: inline-flex;
`,
);

export const PriceInfoWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 0 ${props.theme.spacing.large.l15}
`,
);

export const OriginalPriceTextWrapper = styled.span(
  props => `
  display: inline-flex;
  text-decoration: line-through;
  line-height: 1;
  color: ${props.theme.colors.grey.grey50};
`,
);

export const RupeeSymbolWrapDiv = styled.span(
  props => `
  line-height: 1;
  color: ${props.theme.colors.grey.grey50};
  margin-top: 0.1rem;
`,
);

export const CurrentPriceTextWrapper = styled.span(
  props => `
  display: inline-flex;
  font-size: ${props.theme.font.large.font22};
  font-weight: bold;
  line-height: 1;
  padding: ${props.theme.spacing.small.s8} 0 0;
`,
);

export const CurrentPrice = styled.span(
  props => `
  font-family: ${props.theme.font.fontFamily};
`,
);

export const TaxPriceTextWrapper = styled.span(
  props => `
  display: inline-flex;
  line-height: 1;
  font-size: ${props.theme.font.small};
  padding: ${props.theme.spacing.small.s6} 0 0;
  text-transform: uppercase;
`,
);

export const PerRoomNightTextWrapper = styled.span(
  props => `
  display: inline-flex;
  line-height: 1;
  padding: ${props.theme.spacing.small.s6} 0 0;
  color: ${props.theme.colors.grey.grey50};
`,
);

export const BlueTextWrapperDiv = styled.div(
  props => `
  margin-bottom: ${props.theme.spacing.small.s5};
  align-items: flex-end;
  display:flex;
`,
);

export const DistanceText = styled.div(
  props => `
  margin-top: ${props.theme.spacing.small.s2};
  color: ${props.theme.colors.grey.grey50};
  align-items: flex-end;
  line-height: 1.6;
`,
);

export const HotelLocationText = styled.p`
    display: flex;
    margin-left: .5rem;
    font-size: 1.2rem;
    color: #4a4a4a;
    .divider{
        color: #9b9b9b
        padding-right: .3rem;
    }
    .distanceText{
        color: #249995;
        padding-right: .3rem;
        font-weight: bold;
    }
`;

export const BlueTextWrapper = styled.span(
  props => `
    cursor: pointer;
    display: inline-flex;
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.goBrand.blue};
    line-height: 1;
    &.active{
      color: ${props.theme.colors.white.base};
    }
`,
);

export const SignUpTextWrap = styled.span(
  props => `
    cursor: pointer;
    display: inline-flex;
    font-size: ${props.theme.font.small.font11};
    color: rgba(133, 71, 0, 0.97);
    font-weight:bold;
    margin:0 ${props.theme.spacing.small.s5};
`,
);

export const SignUpPriceWrap = styled.span(
  props => `
    cursor: pointer;
    display: flex;
    align-items:center;
    font-weight:bold;
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.grey75};
`,
);

export const SignUpPerNight = styled.span(
  props => `
    cursor: pointer;
    display: inline-flex;
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.grey75};
`,
);

export const EMITextWrapperDiv = styled.div(
  props => `
  margin-bottom: ${props.theme.spacing.small.s5};
  align-items: flex-end;
  display:flex;
  font-size: ${props.theme.font.base};
  border: .1rem solid ${props.theme.colors.grey.lineGrey};
  padding: ${props.theme.spacing.small.s2};
  border-radius: ${props.theme.misc.borderRadius.base};
`,
);

export const EMIContainer = styled.div(
  props => `
  margin: ${props.theme.spacing.base} 0 0 0;
`,
);

export const EMIWrap = styled.div(
  props => `
  border-radius: ${props.theme.misc.borderRadius.base};
  background-image: linear-gradient(105deg,#34393a,#adaeb2 100%);
  color:${props.theme.colors.white.base};
  font-weight:bold;
  font-family: ${props.theme.font.fontFamily};
  padding: 0 ${props.theme.spacing.small.s3};
  margin-right: ${props.theme.spacing.small.s3};

`,
);

export const EMITextWrapper = styled.div(
  props => `

  color:${props.theme.colors.black.base};
`,
);

export const EMITextPrice = styled.span(
  props => `

  color:${props.theme.colors.grey.grey75};
  font-weight:bold;
  margin-left: ${props.theme.spacing.small.s3};
`,
);

export const SignUpLockOuterWrapper = styled.div(
  props => `
    display : flex;
    align-items:center;
    justify-content: flex-end;
    margin-top: 1rem;
    background: ${props.theme.colors.yellow.lightYellow};
    padding:${props.theme.spacing.base};
    width:100%;
    border-bottom-right-radius: ${props.theme.misc.borderRadius.xxxlarge};
    border-top: .2rem solid ${props.theme.colors.blue.lightBlue};
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15} ${props.theme.spacing.base} ${props.theme.spacing.base};
    position:relative;
`,
);

/*** signup animation on SRP card ***/
export const LockBg = styled.div(
  props => `
    display : flex;
    align-items:center;
    justify-content: flex-end;
    background: ${props.theme.colors.yellow.lightYellow};
    padding:${props.theme.spacing.base};
    width:100%;
    border-bottom-right-radius: ${props.theme.misc.borderRadius.custom(12)};
    border-top: .2rem solid ${props.theme.colors.blue.lightBlue};
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15} ${props.theme.spacing.base} ${
    props.theme.spacing.base
  };
    position:relative;
`,
);

/*** signup animation on SRP card ***/

const ShrinkLock = keyframes`

    0%     { transform: translatex(0px) translatey(0px) scale(1)}
    100%   { transform: translatex(-100px) translatey(120px) scale(0.3);}
`;

const hideBackground = keyframes`
    0% {  opacity: .47; }
    50% {  opacity: .47; }
    100% { visibility: hidden; opacity:0;}
`;

const ShakeLock = keyframes`
    0%   { transform: translateX(0); }
    20%  { transform: translateX(-15px); }
    40%  { transform: translateX(15px); }
    60%  { transform: translateX(-15px); }
    80%  { transform: translateX(15px); }
    100% { transform: translateX(0); }
`;

export const LockBackground = styled.div`
  display: flex;
  position: absolute;
  background: ${props => props.theme.colors.yellow.lightYellow};
  width: 100%;
  height: 100%;
  opacity: 0.47;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${hideBackground} 1.5s 1s;
  animation-fill-mode: forwards;
`;

export const SignUpLockWrapAnimated = styled(SignUpLockIcon)`
  animation-iteration-count: 1;
  animation: ${ShakeLock} 1s 0.3s, ${ShrinkLock} 0.5s 1.3s;
  transform-origin: bottom;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
  opacity: 1;
  position: absolute;
  top: 29%;
  right: 30%;
`;

export const SignUpLockWrap = styled(SignUpLockIcon)`
  transform-origin: bottom;
  opacity: 1;
  position: absolute;
  top: 29%;
  right: 30%;
  transform: translatex(-100px) translatey(120px) scale(0.3);
`;
// =========================== HOTEL PRICING STYLES END HERe ===========================

export const TripAdvisorIconWrapperSpan = styled.span`
  /* border-radius: 50%; */
`;

export const PersuationBlock = styled.div`
  width: 100%;
  display: flex;
  padding: 0 0 15px;
  flex-direction: column;
`;

export const PersuationInnerBlock = styled.div`
  wisrh: 100%;
  display: flex;
  padding-top: 15px;
`;

export const PersuationTag = styled.p`
  display: flex;
  padding: 4px 8px;
  border: 1px solid #e7e7e7;
  background-color: #f1f1f1;
  border-radius: 4px;
  font-size: 11px;
  color: #4a4a4a;
  margin-right: 10px;
  height: 2.2rem;
`;

export const AmenitiesTag = styled.p`
  display: flex;
  font-size: 12px;
  color: #4a4a4a;
  margin-right: 10px;
`;

export const InclusionBlock = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  padding-bottom: 1rem;
`;

export const InclusionHeadText = styled.p`
  font-size: 1rem;
  color: #4a4a4a;
  font-weight: bold;
  letter-sapcing: -0.22px;
  text-transform: uppercase;
`;

export const InclusionText = styled.p`
  font-size: 1.2rem;
  color: #249995;
  padding: 5px 0;
`;

export const AllInclusiveBlock = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  padding-bottom: 1rem;
`;

export const AllInclusiveText = styled.p`
  color: #4a4a4a;
  font-size: 1.2rem;
`;

export const AllInclusiveDetailText = styled.p`
  color: #4a4a4a;
  font-size: 1.2rem;
  font-weight: bold;
  padding-top: 5px;
`;

export const PriceInfoBlock = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`;

export const ShareOptionWrap = styled.div`
  display: flex;
  cursor: pointer;

  
`;

export const ShareOptionLabel = styled.label(
  props => `
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    color: #0091ff;
    font-weight: bold;

    opacity: ${props.disabled ? '0.5' : '1'};
    pointer-events:  ${props.disabled ? 'none' : ''};
    cursor: ${props.disabled ? 'default' : 'pointer'};
    `,
);

export const ShareCheck = styled.input.attrs({type: 'checkbox'})`
  display: inline-flex;
  margin-right: 0.5rem;
  cursor: pointer;
`;

export const ShareText = styled.span`
  display: inline-flex;
  padding: 0 0.5rem;
`;

export const PriceTextWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`;

export const CutPriceText = styled.p`
  font-size: 1.2rem;
  color: #9b9b9b;
  font-weight: bold;
  text-decoration: line-through;
`;

export const NewPriceText = styled.p`
  padding: 0.5rem 0;
  font-size: 2.6rem;
  color: #000000;
  font-weight: 900;
  line-height: 0.85;
  letter-spacing: -0.37px;
`;

export const TaxText = styled.p(
  props => `
    color: ${props.theme.colors.grey.light9b};
    font-size: 1.2rem;
  `
);

export const YouSavePriceText = styled.p`
  color: #eb2026;
  font-size: 1.3rem;
`;

export const YouGetPriceText = styled.p`
  color: #fff;
  font-size: 1.1rem;
  background-color: #249995;
  border-radius: 3px;
  padding: 2px 6px 2px 5px;
  position: relative;
  top:6px;
  width: 110%;
  right: -7px;
  white-space: nowrap;
`;

export const BoldText = styled.span`
  font-weight: 900;
`;

export const PartnerRateWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    padding: 0.5rem;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    background-image: ${props.bgColor || 'linear-gradient(75deg, #9f0469, #f5515f)'};
    position: relative;
    border-radius: 0 0 0.8rem 0;

    // &:before {
    //   content: '';
    //   position: absolute;
    //   top: -10px;
    //   right: 20px;
    //   border-left: 10px solid transparent;
    //   border-right: 10px solid transparent;
    //   border-bottom: 10px solid #e34261;
    // }
  `
);

export const PartnerRateText = styled.p(
  props => `
    font-size: 1.4rem;
    color: ${props.txtColor || props.theme.colors.white.base};
    font-weight: bold;
    letter-spacing: -0.2px;
  `
);

export const MySafetyWrap = styled.div(
  props => `
    align-self: flex-start;
    display: flex;
    margin-top: ${props.theme.spacing.small.s5};
    position: relative;
    cursor: pointer;

    &:hover{
      ${MySafetyTooltip}{
        display: flex !important;
      }
    }
  `
);

export const MySafetyTooltip = styled.div(
  props => `
    width: 35rem;
    display: none;
    background-color: ${props.theme.colors.black.base};
    padding: ${props.theme.spacing.large.l15};
    flex-direction: column;
    box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
    border-radius: ${props.theme.misc.borderRadius.base};
    position: absolute;
    top: 3rem;
    z-index: ${props.theme.misc.zIndex.xxsmall}
  `
);

export const MySafetyHeadText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    font-weight: ${props.theme.font.fontWeight.bold};
    color: ${props.theme.colors.white.base};
  `
);

export const MySafetyInfoList = styled.ul(
  props => `
    width:100%;
    display: flex;
    padding-top: ${props.theme.spacing.small.s6};
    flex-direction: column;
    list-style:none;
    li{
      display: flex;
      align-items: center;
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.white.base};
      padding-bottom: ${props.theme.spacing.small.s5};
    }
  `
)